// services/testimonialService.js
import { apiService } from "./api";

export const testimonialService = {
  // Get all testimonials (admin)
  getAllTestimonials: async (
    page = 1,
    limit = 10,
    search = "",
    status = "",
    type = ""
  ) => {
    const params = { page, limit };
    if (search) params.search = search;
    if (status && status !== "all") params.status = status;
    if (type && type !== "all") params.type = type;

    return await apiService.get("/testimonials", { params });
  },

  getTestimonialStats: async () => {
    return await apiService.get("/testimonials/stats");
  },

  getUserTestimonials: async (page = 1, limit = 10, status = "") => {
    const params = { page, limit };
    if (status) params.status = status;

    return await apiService.get("/testimonials/my", { params });
  },

  createTestimonial: async (testimonialData) => {
    return await apiService.post("/testimonials", testimonialData);
  },

  updateTestimonialStatus: async (id, status, reviewNotes = "") => {
    return await apiService.patch(`/testimonials/${id}/status`, {
      status,
      reviewNotes,
    });
  },
  // not in use right now
  // getTestimonialById: async (id) => {
  //   return await apiService.get(`/testimonials/${id}`);
  // },

  deleteTestimonial: async (testimonialId) => {
    return await apiService.delete(`/testimonials/${testimonialId}`);
  },
};

export default testimonialService;
